import React from 'react'
import { IconCarambola } from '@tabler/icons-react';
import Rating from '../Rating';
import avatar from '../../assets/images/avatar-default-svgrepo-com.svg'

const UserCard = ({ paymentData }) => {
  return (
    <div className='w-full lg:max-w-[600px] flex flex-col gap-4  p-4 rounded-lg text-sm shadow-lg self-start flex-none  bg-white border-2 border-gray-100'>
      <div className='w-full sm:h-20 flex flex-wrap sm:justify-between sm:items-center gap-2'>
        <div className='flex h-full'>
          <div class=" h-20 w-20 rounded-lg flex justify-center items-center bg-gray-100">
            {/* image */}
            <img src={avatar} className='w-full h-full rounded-lg object-cover' alt='user-name' />
          </div>
          <div className='h-full flex flex-col flex-auto ml-3 justify-center'>
            {/* user details */}
            <h1 className='font-bold'>{paymentData.fullName}</h1>
            {/* <p className=''>Example Desc.</p> */}
          </div>
        </div>
        {/* tip amount */}
        <div className='sm:h-10 w-40 flex justify-between items-center p-2 bg-gray-100 rounded-lg font-bold'>
          <IconCarambola stroke={2} />
          <p>Thank you</p>
          {/* <p>Tip: <span>Kes {paymentData?.defaultAmount}</span></p> */}
        </div>
      </div>
      <Rating />
      <div className=''>{paymentData.description}</div>
    </div>
  )
}

export default UserCard